import { Component } from '@verndale/core';
import Swiper from 'swiper';

class Lounge extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $slidingContent: this.$el.find('.lounge__additional'),
      $slidingContentPanel: this.$el.find('.lounge-additional__content'),
      $slidingTrigger: this.$el.find('.lounge-additional__title'),
      $gallery: this.$el.find('.lounge__gallery'),
      $gallerySlider: this.$el.find('.swiper-container'),
      $galleryTrigger: this.$el.find('.lounge__gallery-trigger'),
      $loungeAmenitiesInfo: this.$el.find('.lounge-details__amenities'),
      $loungeFoodInfo: this.$el.find('.lounge__food'),
      $loungeFacilitiesInfo: this.$el.find('.lounge__facilities'),
      $loungeEntertainmentInfo: this.$el.find('.lounge__entertainment')
    };

    this.dom.$slidingContentChevron = this.dom.$slidingTrigger.find('.chevron');
    this.dom.$galleryCloseBtn = this.dom.$gallery.find('.btn-close');
    this.initSlider();
  }

  addListeners() {
    this.dom.$slidingTrigger.on('click touchstart', ::this.toggleContent);
    this.dom.$galleryTrigger.on('click touchstart', ::this.showGallery);
    this.dom.$galleryCloseBtn.on('click touchstart', ::this.hideGallery);
  }

  initSlider() {
    if (this.dom.$gallerySlider.length > 0) {
      this.swiper = new Swiper(this.dom.$gallerySlider, {
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          renderFraction: (currentClass, totalClass) => {
            return (
              `<span class="${currentClass}"></span>` +
              ' of ' +
              `<span class="${totalClass}"></span>`
            );
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      });
    }
  }

  showGallery(e) {
    e.stopPropagation();
    e.preventDefault();
    this.dom.$gallery.addClass('is-active');
  }

  hideGallery(e) {
    e.stopPropagation();
    e.preventDefault();
    this.dom.$gallery.removeClass('is-active');
  }

  toggleContent(e) {
    e.stopPropagation();
    e.preventDefault();

    this.dom.$slidingContentPanel.slideToggle();
    this.dom.$slidingContent.toggleClass('is-open');

    if (this.dom.$slidingContent.hasClass('is-open')) {
      //Update chveron
      this.dom.$slidingContentChevron.removeClass('bottom').addClass('top');
      //Update trigger text
      this.dom.$slidingTrigger
        .find('a')
        .text(this.dom.$slidingTrigger.data('textClose'));
    } else {
      //Update chveron
      this.dom.$slidingContentChevron.removeClass('top').addClass('bottom');
      //Update trigger text
      this.dom.$slidingTrigger
        .find('a')
        .text(this.dom.$slidingTrigger.data('textOpen'));
    }
  }

  renderAvailableInfo($infoPanel, availableOptionsArr) {
    if (availableOptionsArr.length > 0) {
      availableOptionsArr.forEach(option => {
        $infoPanel.find(`[data-name="${option}"]`).show();
      });
    }
  }
}
export default Lounge;
